import * as Sentry from "@sentry/react";

Sentry.init({
  dsn:
    window.__RUNTIME_CONFIG__?.SENTRY_DSN ||
    import.meta.env.VITE_SENTRY_DSN ||
    "",
  environment: import.meta.env.MODE,
  release: __APP_VERSION__,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: !!(
    window.__RUNTIME_CONFIG__?.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN
  ),
});
